import { FC } from 'react';
import { Box, Card, CardContent, Skeleton, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { Loader } from 'ui/Loader';
import { getTotalTaxes, getTotalTaxesLoader } from 'redux/reducers/dashboard/selectors';
import { MONTH_ARRAY } from '../constants';
import './styles.css';

const dateToday = new Date();

export const TotalTaxes: FC = () => {
	const totalTaxes = useSelector(getTotalTaxes);
	const totalTaxesLoading = useSelector(getTotalTaxesLoader);
	return (
		<Card
			sx={{
				mb: 2,
				borderRadius: '12px',
				'& .MuiCardContent-root': { padding: '8px 16px 16px 16px!important' },
			}}
		>
			<CardContent>
				<Typography
					variant="h5"
					color="primary"
					sx={{
						fontSize: '1.2rem',
						fontWeight: 'bold',
						marginBottom: '16px',
					}}
				>
					Total Taxes Collected for{' '}
					{`${MONTH_ARRAY[dateToday.getUTCMonth()]} ${dateToday.getUTCFullYear()}`}
				</Typography>
				<Box
					sx={{
						display: 'flex',
						flexDirection: { md: 'row', xs: 'column' },
						justifyContent: 'space-between',
						gap: 2,
						height: '100%',
						alignItems: 'stretch',
					}}
				>
					{!totalTaxesLoading && (totalTaxes || totalTaxes === 0) && (
						<Box
							sx={{
								fontSize: '3rem',
								fontWeight: 'bold',
								color: '#016193',
								backgroundColor: '#bdd2df99', // '#0092de24',
								borderRadius: '12px',
								padding: '30px 30px',
								height: 'auto',
								display: 'flex',
								alignItems: 'center',
							}}
						>
							<AmountAndCurrency amount={+totalTaxes} currency="EUR" size={3} bold type="symbol" />
						</Box>
					)}
					{totalTaxesLoading && (
						<Skeleton
							variant="rectangular"
							height="132px"
							sx={{
								borderRadius: '12px',
								minWidth: '193px',
							}}
						/>
					)}
					{!totalTaxesLoading && (totalTaxes || totalTaxes === 0) && (
						<Box
							sx={{
								display: 'flex',
								// mt: -2,
								backgroundColor: '#de000024', // '#0092de24',
								borderRadius: '12px',
								padding: '10px',
								height: 'auto',
								width: { md: '100%', sx: 'auto' },
							}}
						>
							<Typography
								sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#000000d0', ml: '10px' }}
							>
								<b>Please note that the tax amount stated here is an estimate.</b>
								<br />
								Exact tax figures will be provided at the beginning of the subsequent month in your
								Fiscal VAT reports.
								<br />
								These reports will incorporate specific exchange rates issued by EU and UK
								authorities and will consider any adjustments and refunds made during the month.
							</Typography>
						</Box>
					)}
					{totalTaxesLoading && (
						<Skeleton
							variant="rectangular"
							height="132px"
							sx={{
								borderRadius: '12px',
								width: { md: '100%', sx: 'auto' },
							}}
						/>
					)}
				</Box>
			</CardContent>
		</Card>
	);
};
